module.exports = __webpack_public_path__ + "img/logos.05b2fe58.png";